import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import _ = require('lodash');
import { Subject } from 'rxjs';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';

@Component({
  selector: 'app-risk-review-details-popup',
  templateUrl: './risk-review-details-popup.component.html',
  styleUrls: ['./risk-review-details-popup.component.css']
})
export class RiskReviewDetailsPopupComponent implements OnInit {
 @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();

  @Input('formDetails') formDetails: any;
  reviewerFormDetails: any;
  enableTableShow: Boolean = false;

  constructor(
    private riskEvaluationService: RiskEvaluationService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private router: Router
  ) {}

  ngOnInit() {
    var self = this;

    this.riskEvaluationService
      .getReviewersDetailsEvaluationForm(this.formDetails._id)
      .then((response) => {
        this.reviewerFormDetails = response.EvaluationQuestionnaire[0];
        if (_.size(this.reviewerFormDetails.Reviewers) > 0) {
          this.enableTableShow = true;
        } else {
          this.enableTableShow = false;
        }
        this.dtTrigger.next();
        var reviewerStatus;
        var i = 0;
        for (i; i < this.reviewerFormDetails.Reviewers.length; i++) {
          reviewerStatus = this.reviewerFormDetails.Reviewers[i].ReviewerStatus;
          if (reviewerStatus == 'Approve')
            this.reviewerFormDetails.Reviewers[i].ReviewerStatus = 'Approved';
          else if (reviewerStatus == 'Reject')
            this.reviewerFormDetails.Reviewers[i].ReviewerStatus = 'Rejected';
          else if (reviewerStatus == 'Review')
            this.reviewerFormDetails.Reviewers[i].ReviewerStatus =
              'To be Reviewed';
        }
      });
  }

  editEvaluationForm(ReviewerId) {
    this.activeModal.close();
    this.router.navigate([
      'structure',
      {
        outlets: {
          'structure-outlet': [
            'riskQuestionnaireReview',
            this.formDetails._id,
            ReviewerId,
          ],
        },
      },
    ]);
  }

  close() {
    this.activeModal.close();
  }
}
